export const BASE_URL = process.env.REACT_APP_BASE_URL;

//auth url
export const LOGIN_URL = "/api/admin/login/admin";




// User url
export const GET_USER_URL = "/api/admin/getUserLevel";


//  CATEGORIES TYPE
export const GET_ADMIN_CATEGORY_TYPE_URL = "/api/admin/findUserCategoryType";


// SUB CATEGORIES URL
export const GET_ADMIN_SUB_CATEGORY_URL = "/api/admin/findUserCategorySubTypeByUserCategoryTypeId/";


//INSITUTE REGISTRATION EXCEL IMPORT
export const IMPORT_ADMIN_EXCEL = "/api/admin/importRegistration";
export const GET_ORGANISATION_LIST = "/api/admin/getRegistrationOrganizationData";

// INSITUTE VERFICATION 
export const GET_ID_INSITUTE_VERFICATION_URL = "/api/admin/getRegistrationOrganizationDataById/";
export const INSERT_INCORRECT_VERIFICATION_FORM_URL = "/api/admin/insertCorrection";

// INDIVIDUAL URL
export const GET_INDIVIDUAL_LIST = "/api/admin/getRegisteredUser";
export const GET_ID_INDIVIDUAL_VERFICATION_URL = "/api/admin/getRegisteredUserById/";
export const GET_ID_INDIVIDUAL_CLEAR_VERFIDATION_URL = "/api/admin/generateIndivisualAtom";

// PASS VERIFY LIST URL
export const GET_VERIFIED_LIST = "/api/admin/getUsersVerifiedList";
export const GET_VERIFIED_VIEW_LIST = "/api/admin/getUsersById/";